import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import ValidateCustomerNrGql from '@/extensions/shop/store/graphql/queries/ValidateCustomerNr.gql';

export default {
    validateNR: (nr, shopID = null, excludedCustomerID = null) =>
        new Promise((resolve, reject) => {
            let variables = { nr };
            if (shopID) variables.shop = parseInt(shopID);
            if (excludedCustomerID) variables.excludedCustomer = parseInt(excludedCustomerID);

            apolloClient
                .query({
                    query: ValidateCustomerNrGql,
                    variables
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_ValidateCustomerNr))
                .catch(err => reject(err));
        }),
}
